import React, { useEffect } from 'react';
import Header from 'marketing-components/dist/components/organisms/header';
import Footer from 'marketing-components/dist/components/organisms/footer';
import { get, isEmpty } from 'lodash';
import { hydrate } from 'react-dom';

const loadLoggedOutHeaderFooter = () => {
  if (!get(window, 'fpti.lgin', false)) {
    const loggedOutHeaderConfig = get(
        window,
        'loggedOutHeaderFooterProps.loggedOutHeaderConfig',
        {}
      ),
      loggedOutHeaderContent = get(
        window,
        'loggedOutHeaderFooterProps.loggedOutHeaderContent',
        {}
      ),
      loggedOutFooterContent = get(
        window,
        'loggedOutHeaderFooterProps.loggedOutFooterContent',
        {}
      );

    const LoggedOutHeader = () => {
      useEffect(() => {
        if (window.location.hostname.includes('localhost')) {
          const handleLocalhostLogin = e => {
            e.preventDefault();
            window.location.href = `https://www.msmaster.qa.paypal.com/signin?returnUri=${window.location.href}`;
          };
          const loginBtn = document.getElementById('ul-btn');
          if (loginBtn) {
            loginBtn.addEventListener('click', handleLocalhostLogin, false);
            return () => {
              loginBtn.removeEventListener(
                'click',
                handleLocalhostLogin,
                false
              );
            };
          }
        }
        return null;
      }, []);

      return (
        <Header
          config={loggedOutHeaderConfig}
          content={loggedOutHeaderContent}
        />
      );
    };

    const LoggedOutFooter = () => <Footer content={loggedOutFooterContent} />;

    if (!isEmpty(loggedOutHeaderConfig) && !isEmpty(loggedOutHeaderContent)) {
      hydrate(
        <LoggedOutHeader />,
        document.getElementById('merchanthub-loggedout-header')
      );
    }
    if (!isEmpty(loggedOutFooterContent)) {
      hydrate(
        <LoggedOutFooter />,
        document.getElementById('merchanthub-loggedout-footer')
      );
    }
  }
};

export default loadLoggedOutHeaderFooter;
